"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// message StatusV2Response {
//   StatusState status = 1;
//   repeated TransferEvent transfer_sequence = 2;
//   NextBlockingTransfer next_blocking_transfer = 3;
//   TransferAssetRelease transfer_asset_release = 4;
//   StatusError error = 5;
//   StatusState state = 6;
// }
//# sourceMappingURL=lifecycle.js.map